export default "__VITE_ASSET__CGgBACY0__"